import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormLabel,
  IconButton,
  Slide,
  TextField,
  Typography,
} from "@mui/material";
import { forwardRef } from "react";
import { usePromiseTracker } from "react-promise-tracker";
import { Close, Message } from "@mui/icons-material";
import { END_POINT } from "../../utils/End-points";
import IconConstants from "../../utils/IconConstants";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const CustomerInfo = ({ open, setOpen }) => {
  const { promiseInProgress: initiateJob } = usePromiseTracker({
    area: END_POINT.CUSTOMER.GET_ALL_BLACKLIST,
  });

  const handleClose = () => {
    setOpen(false);
  };

  const info = [
    { label: "Location", value: "Chennai" },
    { label: "Email", value: "navedansari@gmail.com" },
    { label: "Location", value: "Jan 1, 1980" },
  ];

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      PaperProps={{
        sx: {
          position: "absolute",
          top: "50%",
          right: 6,
          transform: "translateY(-50%)",
          margin: 0,
          width: "26.04%",
          height: "98dvh",
          borderRadius: "20px",
          boxShadow: "0px 0px 15px 0px #0000001A",
          maxHeight: "none",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mt: "1%",
        }}
      >
        <Typography sx={{ fontSize: { sm: "1.11vw" }, fontWeight: 700 }}>
          Room no: 104
        </Typography>

        <IconButton size="small" onClick={handleClose}>
          <Message fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ width: "97%", margin: "0 auto" }}>
        <Box sx={{ textAlign: "center" }}>
          <Box
            sx={{
              height: { md: "11.03vw" },
              width: { md: "9.9vw" },
              margin: "0 auto",
            }}
          >
            <img
              src={IconConstants.Person}
              alt=""
              style={{ width: "100%", height: "100%" }}
            />
          </Box>
          <Typography
            sx={{
              color: "#09121E",
              fontSize: { md: "1.35vw", fontWeight: 600 },
            }}
          >
            Naved Ansari
          </Typography>

          <Typography
            sx={{
              color: "#798494",
              fontSize: { md: "1.35vw", fontWeight: 600 },
              margin: "2% 0 8% 0",
            }}
          >
            +91 982 602 9995
          </Typography>
        </Box>

        {info.map((item, ind) => (
          <Box
            key={item.label}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderBottom:
                ind === info.length - 1 ? "none" : "1px solid #ECECEC",
              m: "6% 0",
            }}
          >
            <Typography
              sx={{
                color: "#798494",
                fontSize: { md: "0.98vw", fontWeight: 500 },
              }}
            >
              {item.label}
            </Typography>
            <Typography
              sx={{
                color: "#09121E",
                fontSize: { md: "0.98vw", fontWeight: 500 },
              }}
            >
              {item.value}
            </Typography>
          </Box>
        ))}

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            margin: "8% 0",
          }}
        >
          <Typography
            sx={{
              color: "#09121E",
              fontSize: { md: "1.11vw", fontWeight: 600 },
            }}
          >
            Recent Activity
          </Typography>

          <Typography
            sx={{
              color: "#0084FF",
              fontSize: { md: "0.98vw", fontWeight: 500 },
              cursor : "pointer"
            }}
          >
            View All
          </Typography>
        </Box>

        <Box
          sx={{
            boxShadow: "0px 0px 10px 0px #0000001A",
            backgroundColor: " #F8F9FB",
            borderRadius: "20px",
            height: "30%",
          }}
        ></Box>
      </DialogContent>
    </Dialog>
  );
};

export default CustomerInfo;
